import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  forwardRef,
  OnChanges,
  SimpleChanges, ViewChildren, Renderer2, HostListener, ElementRef,
  AfterViewInit,
  DoCheck
} from '@angular/core';
import { URLSearchParams } from "@angular/http";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ParameterService } from '../../utils/services/parameter.service';


@Component({
  selector: 'app-hotel-dropdown',
  templateUrl: './hotel-dropdown.component.html',
  styleUrls: ['./hotel-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HotelDropdownComponent),
      multi: true
    }
  ]
})
export class HotelDropdownComponent implements  OnInit, AfterViewInit, DoCheck {
  public selectedDataList: Array<any> = [];
  public dataList: Array<any>;
  private keyEventSubject: Subject<string> = new Subject();
  private selectedIndex = 0;
  @ViewChildren("dropdownItem") dropdownItems;
  @ViewChild("dropdownMenu") dropdownMenu;
  @Input() isClearable = true;
  @Output()
  onCitySelected: EventEmitter<any> = new EventEmitter<any>();
  public searchInputControl = new FormControl();
  @ViewChild("dropdownButton") dropdownButton: ElementRef;
  @ViewChild("searchInput") searchInput;
  @Input() searchable: boolean = true;
  public visibleCount = 0;



  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedCities) {
      this.searchParams.set("limit", "10");
      this.searchParams.set("offset", "0");
      this.searchParams.set("sortBy", "name");
      this.searchParams.set("sortType", "ASC");
      /*  this.searchParams.set("OrganizationHotel.status_Eq", "Active"); */
      if (this.selectedCities.length > 0) {
        this.searchParams.set('cityId_In', this.selectedCities.map(p => p.bizihotelCityId).toString());
      }
      let newSelecteds = [];
      if (this.selectedCities && this.selectedCities.length > 0) {
        this.selectedCities.forEach(city => {
          this.selectedHotels.forEach(hotel => {
            if (hotel.cityId === city.bizihotelCityId) {
              newSelecteds.push(hotel);
            }
          }
          )
        })
      } else {
        newSelecteds = this.selectedHotels;
      }


      this.fetchCities();
      this.setSelectedHotels(newSelecteds)
    }
  }


  @Input() isCrossed: boolean;
  @Input() singleSelect: boolean = false;
  @Input() organizationID: number;
  @Input() subscribedAppName: string = "Btm";
  @Input() selectedCities: Array<any> = [];
  public placeholder = "DATA_SELECTION.selectHotel";
  @Input() setTheOnlyItemAsSelected: boolean = true;

  @Input() zone;
  @Input() selectedHotels: Array<BiziHotel> = [];
  @Output() onHotelSelected: EventEmitter<any> = new EventEmitter<any>();
  public searchParams: URLSearchParams = new URLSearchParams();
  public propagateChange = (_: any) => {
  };

  @HostListener("window:click", ["$event"])
  clickHandler(event) {
    if (!(this.elementRef.nativeElement.contains(event.target))) {
      this.hideDropDown();
    }
  }

  constructor(public httpService: ParameterService,private renderer: Renderer2,private elementRef: ElementRef) {

  }

  ngOnInit() {
    this.keyEventSubject.debounceTime(300).subscribe(event => {
      this.handleKeyDown(event);
    });

    this.searchParams.set("limit", "10");
    this.searchParams.set("offset", "0");
    this.searchParams.set("sortBy", "name");
    this.searchParams.set("sortType", "ASC");
/*     this.searchParams.set("OrganizationHotel.status_Eq", "Active");
 */   
    this.searchInputControl.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value) {
        if (value.length > 0) {
          this.onSearchTextChanged(value);
        } else {
          this.onSearchTextChanged(null);
        }
      } else {
        this.onSearchTextChanged(null);
      }
    })
    this.fetchCities();
  }

  

  setMenuDataForInitialize(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
      if (this.setTheOnlyItemAsSelected && (this.selectedDataList && this.selectedDataList.length == 0) && (this.dataList && this.dataList.length == 1)) {
        this.setSelectedData([...this.dataList]);
      }
    } else {
      this.dataList = [];
    }
  }
  isItemSelected(item: any) {
    if (this.selectedDataList) {
      this.selectedDataList.findIndex((element) => element['id'] === item['id']) > -1 ? true : false;
     if(this.selectedDataList[0]){
      console.log(this.selectedDataList[0].id)
     }
      return this.selectedDataList.findIndex((element) => element['id'] === item['id']) > -1 ? true : false;
    }
    return false;
  }
  toggleDropdownMenu() {
    if (this.dropdownMenu.nativeElement.classList.contains("show")) {
      this.hideDropDown();
    }
    else {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, "hide");
      this.showDropDown();
    }
  }

  fetchCities() {
    this.httpService.getHotels(this.searchParams).subscribe(
      response => {
        this.setMenuDataForInitialize(response.data.rows);
      }, error => {
        this.setMenuDataForInitialize([]);
      }
    );

    this.setSelectedHotels(this.selectedHotels);
  }
  writeValue(value: any) {
    this.setSelectedHotels(value);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

  onDataSelected(selectedHotels: Array<BiziHotel>) {
    this.onHotelSelected.emit(selectedHotels);
    this.propagateChange(selectedHotels);
  }

  ngDoCheck() {
    if (this.dropdownButton && this.dropdownButton.nativeElement && this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0]) {
      this.visibleCount = Math.floor(this.dropdownButton.nativeElement.offsetWidth / this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0].offsetWidth) - 2;
    }
  }
  ngAfterViewInit() {

  }
  setSelectedHotels(selectedHotels: Array<BiziHotel>) {
    if (Array.isArray(selectedHotels) && selectedHotels && selectedHotels.length > 0) {
      let searchParams: URLSearchParams = new URLSearchParams();
      let ids = selectedHotels.map((item) => {
        return item["id"]
      });
      searchParams.set("limit", "10");
      searchParams.set("offset", "0");
      searchParams.set("sortBy", "name");
      searchParams.set("sortType", "ASC");
      /*       searchParams.set("OrganizationHotel.status_Eq", "Active");
       */
      searchParams.set("id_In", ids.toString());
      this.httpService.getHotels(searchParams).subscribe(
        response => {
          this.setSelectedData(response.data.rows);
        }, error => {
          this.setSelectedData([]);
        }
      );
    } else {
      this.setSelectedData([]);
    }
  }
  setSelectedData(selectedDataList: Array<any>) {
    if (Array.isArray(selectedDataList)) {
      this.selectedDataList = selectedDataList;
    } else {
      this.selectedDataList = [];
    }
  }
  keyDown(event) {
    //event.preventDefault();
    //40 down
    //38 UP
    //27 Escape
    //13 Enter
    //this.logger.log(event);
    this.keyEventSubject.next(event);
  }
  handleKeyDown(event) {
    switch (event.keyCode) {
      case 40:
        if (this.selectedIndex > this.dataList.length - 1) {
          this.selectedIndex = this.dataList.length - 1;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex++;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 38:
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex--;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 27:
        this.hideDropDown();
        break;
      case 13:
        this.onDataPicked(this.dataList[this.selectedIndex]);
        break;
    }
  }
  onDataPicked(data: any) {
    if (data) {

      if (this.singleSelect) {
        if (this.selectedDataList.length == 0) {
          this.selectedDataList[0] = data;
        } else {
          if (data['id'] === this.selectedDataList[0]['id']) {
            if (this.isClearable && this.selectedDataList.length > 0)
              this.selectedDataList.splice(0, 1);
          } else {
            this.selectedDataList[0] = data;
          }
        }

        this.onCitySelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
        this.hideDropDown();
      } else {
        var selectedIndex = this.selectedDataList.findIndex((element) => element['id'] === data['id']);
        if (selectedIndex > -1) {
          this.selectedDataList.splice(selectedIndex, 1);
        } else {
          this.selectedDataList.push(data);
        }
        this.onCitySelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
      }
    }

  }

  hideDropDown() {
    this.renderer.removeClass(this.dropdownMenu.nativeElement, "show");
  }


  onLoadMore(offset) {
    this.searchParams.set("offset", offset.toString());
    this.httpService.getHotels(this.searchParams).subscribe(
      response => {
        response.data.rows.forEach((element) => {
          this.addMenuData(element);
        });
      }, error => {
      }
    );
  }
  addMenuData(data) {
    this.dataList.push(data);
  }

  showDropDown() {
    this.renderer.addClass(this.dropdownMenu.nativeElement, "show");
    if (this.dropdownItems.toArray()[this.selectedIndex]) {
      this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
    }
    if (this.searchable) {
      this.searchInput.nativeElement.click();
      this.searchInput.nativeElement.focus();
    }

  }
  onSearchTextChanged(searchText) {
    this.searchParams = new URLSearchParams();
    this.searchParams.set("limit", "10");
    this.searchParams.set("offset", 0 + "");
    this.searchParams.set("sortBy", "name");
    this.searchParams.set("sortType", "ASC");
    /* this.searchParams.set("OrganizationHotel.status_Eq", "Active"); */

    if (searchText) {
      this.searchParams.set("name_Like", searchText);
      this.httpService.getHotels(this.searchParams).subscribe(
        response => {
          this.setMenuDataForLoadMore(response.data.rows);
        }, error => {
          this.setMenuDataForLoadMore([]);
        }
      );
    } else {
      this.httpService.getHotels(this.searchParams).subscribe(
        response => {
          this.setMenuDataForLoadMore(response.data.rows);
        }, error => {
          this.setMenuDataForLoadMore([]);
        }
      );
    }
  }
  onScroll() {
    this.searchParams.set('offset', this.dataList.length.toString());
    this.httpService.getHotels(this.searchParams).subscribe(
      response => {
        response.data.forEach(item => {
          this.dataList.push(item)
        });
      },
      error => { }
    );
  }

  setMenuDataForLoadMore(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
    } else {
      this.dataList = [];
    }
  }

}


export class BiziHotel {
  id: number;
  hotelId: number;
  name: string;
  cityId: string;
}


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/hotel-dropdown/hotel-dropdown.component.ts